import { render, staticRenderFns } from "./AsignaturaComponent.vue?vue&type=template&id=7a89929a"
import script from "./AsignaturaComponent.vue?vue&type=script&lang=js"
export * from "./AsignaturaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports